import React from "react";
import ReactTooltip from "react-tooltip";

import PriceEvolution from "../../../product/components/PriceEvolution";
import { Visible } from "../../../core/components";
import { SpecificationItem } from "../../../components";

const tooltopMarket = `
  <strong>Market Price</strong> is an industry average calculation of prices paid on recent online transactions.
  <br /><br />
  <strong>Actual</strong>: Average listings on the market in the last 30 days.
  <br /><br />
  <strong>3M</strong>: Average listings on the market in the last 90 days.
  <br /><br />
  <strong>12M</strong>: Average listings on the market in the last 365 days.
`;

const tooltopTrade = `
  <strong>Trade Price</strong> is a private industry average calculation of prices paid on recent traders transactions.
  <br /><br />
  <strong>Actual</strong>: Average listings on the trade market in the last 30 days.
  <br /><br />
  <strong>3M</strong>: Average listings on the trade market in the last 90 days.
  <br /><br />
  <strong>12M</strong>: Average listings on the trade market in the last 365 days.
`;

const DataPoints = ({ points }) =>
  points ? (
    <>
      <span className="data-points">&nbsp;-&nbsp;{points}&nbsp;</span>
      <span className="data-points">data point{points == 1 ? "" : "s"}</span>
    </>
  ) : null;

const PriceDetails = ({ user, analytics: { market, trade } }) => {
  return (
    <>
      <div className="row">
        <Visible when={user?.is_admin || user?.can_see_market_prices}>
          <div className="col-sm-7 col-12 mb-4">
            <h3 className="mb-4">
              Market Price
              <span
                className="info-tooltip-trigger"
                data-html="true"
                data-tip={tooltopMarket}
                data-type="light"
              >
                i
              </span>
            </h3>
            <SpecificationItem
              label="ACTUAL"
              value={market?.month?.gbp}
              currency
              na
              extra={<DataPoints points={market?.month?.points} />}
            />
            <SpecificationItem
              label="3M"
              value={market?.quarter?.gbp}
              currency
              na
              extra={<DataPoints points={market?.quarter?.points} />}
            />
            <SpecificationItem
              label="12M"
              value={market?.year?.gbp}
              currency
              na
              extra={<DataPoints points={market?.year?.points} />}
            />

            <h3 className="mb-4 mt-4">Evolution</h3>
            <SpecificationItem
              label="RETAIL GBP"
              value={market?.retail?.gbp}
              na
              currency
            />
            <SpecificationItem
              label="RETAIL EURO"
              value={market?.retail?.eur}
              na
              currency="eur"
            />
            <SpecificationItem
              label="EVOLUTION"
              value={<PriceEvolution {...{ analytics: market }} />}
              na
            />
          </div>
        </Visible>
        <Visible when={user?.is_admin || user?.can_see_trade_prices}>
          <div className="col-sm-5 col-12">
            <h3 className="mb-4">
              Trade Price
              <span
                className="info-tooltip-trigger"
                data-html="true"
                data-tip={tooltopTrade}
                data-type="light"
              >
                i
              </span>
            </h3>
            <SpecificationItem
              label="ACTUAL PRICE"
              labelClass="d-sm-none"
              value={trade?.month?.gbp}
              currency
              na
              extra={<DataPoints points={trade?.month?.points} />}
            />
            <SpecificationItem
              label="3M"
              labelClass="d-sm-none"
              value={trade?.quarter?.gbp}
              currency
              na
              extra={<DataPoints points={trade?.quarter?.points} />}
            />
            <SpecificationItem
              label="12M"
              labelClass="d-sm-none"
              value={trade?.year?.gbp}
              currency
              na
              extra={<DataPoints points={trade?.year?.points} />}
            />

            <h3 className="mb-4 mt-4">Evolution</h3>
            <SpecificationItem
              label="RETAIL GBP"
              labelClass="d-sm-none"
              value={trade?.retail?.gbp}
              na
              currency
            />
            <SpecificationItem
              label="RETAIL EURO"
              labelClass="d-sm-none"
              value={trade?.retail?.eur}
              na
              currency="eur"
            />
            <SpecificationItem
              label="EVOLUTION"
              labelClass="d-sm-none"
              value={<PriceEvolution {...{ analytics: trade }} />}
              na
            />
          </div>
        </Visible>
      </div>

      <ReactTooltip />
    </>
  );
};

export default PriceDetails;
